// build-women-fv-fonts.ts が生成する。手で直さない
export const FV_FONT_FILES = {
  "sans400": "/assets/fonts/women-fv/sans400-b8f81c2d.woff2",
  "sans700": "/assets/fonts/women-fv/sans700-ed0d3be1.woff2",
  "sans900": "/assets/fonts/women-fv/sans900-8da6b8e9.woff2",
  "serif700": "/assets/fonts/women-fv/serif700-aaa17ce1.woff2"
} as const;

/* 切り出しに入れた字。women-fv-fonts.test.ts が、画面の字がここに全部あるかを見る */
export const FV_FONT_CHARS = " !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~×―…※←→、。「」『』〜あいかがきくけしすずだでとなにのはばぶへまもよらりるれをアイウエカキクグコサジスセタットニピブプポミムモュラリルレロンヶ・ー上世中主代以件会伴体作個働入全内円別募卒受問回在型基声女学宅定実専年役後性成手授料新日時月未本業次点無現生用画社答経継続義要計設講質走超践身返週選金録開間集額験！％＆（）＋，－．：；？［］｜～";
